import * as util from "lib/util.js";
import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import { httpError } from "store/httpError.js";
import kbIpcClass from "lib/kbIpcClass.js";
import "@vaadin/vaadin-icons/vaadin-icons.js";
import "@vaadin/vaadin-split-layout/vaadin-split-layout.js";
import { IronResizableBehavior } from "@polymer/iron-resizable-behavior/iron-resizable-behavior.js";
import "../bdsWebComp/3D/ipc-3d-topic";

class KbIpcTopic extends LitElement {
  constructor() {
    super();
  }

  static get properties() {
    return {
      hash: { type: String },
    };
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    if (this.node) {
      this.lastNodeHref = this.node?.href;
      this.refreshData();
    }
    this.theadHeight = 10;
  }

  refreshData() {
    // storeInstance.dispatch("getTopicHtmlBody", this.node.href )    ;
    if (this.imgDiv) {
      this.imgDiv.innerHTML = "";
    }
    if (this.bottom) {
      this.bottom.innerHTML = "";
    }
    this.bottom = null; //force reload of ipcObj
    this.top = null;
    this.imgDiv = null;
    if (this.node?.href) {
      this.htmlBody = null;
      PubSub.publish("requestout", null);
      fetch(
        this.state.kb_rest_server +
          "/kb/jrest/getHtmlBody?kbrid=" +
          this.node.href
      )
        .then(
          function (response) {
            if (!response.ok) {
              httpError(response, storeInstance);
              throw Error(); //to bail out of promise chain
            }
            return response;
          }.bind(this)
        )
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          this.htmlBody = data;
          storeInstance.dispatch("touch");
        })
        .catch(function (error) {})
        .finally(function () {
          PubSub.publish("requestin", null);
        });
    }
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    if (this.node?.href) {
      if (this.lastNodeHref != this.node.href) {
        this.lastNodeHref = this.node.href;
        this.refreshData();
      }
    }
    if (this.htmlBody) {
      this.myRender();
    }
  }

  determineIpcType() {
    var parser = new DOMParser();
    var testIpc = parser.parseFromString(this.htmlBody, "text/xml");
    return testIpc.children[0].getAttribute("class");
  }

  // added to determine if IPC is a 3D topic
  ipc3DTopic() {
    return html` <ipc-3d-topic .htmlBody="${this.htmlBody}"></ipc-3d-topic> `;
  }

  setFragementActive() {
    if (this.hash) {
      this.hash = this.hash.replace("#", "");
      let rowEl = this.shadowRoot.querySelector(`[id$='${this.hash}']`);
      rowEl.click();
    }
  }

  myRender() {
    // if 3D then bail out and load 3D
    var ipcType = this.determineIpcType();
    if (ipcType === "Ipc3DTopic") {
      render(this.ipc3DTopic(), this.shadowRoot);
      return;
    }
    render(this.ipcTopicTemplate(), this.shadowRoot);
    if (!this.imgDiv) {
      this.imgDiv = this.shadowRoot.querySelector("#imgdiv");
    }
    if (!this.bottom) {
      this.bottom = this.shadowRoot.querySelector("#bottom");
    }
    if (!this.top) {
      this.ipcObj = new kbIpcClass();
      this.ipcObj.addToCart = this.state.add_to_cart;
      this.ipcObj.zoomCallback = this.zoom.bind(this);
      this.ipcObj.hsClickCallback = this.hsClick.bind(this);
      this.ipcObj.rowClickCallback = this.rowClick.bind(this);
      this.ipcObj.orderBtnClickCallback = this.orderBtnClick.bind(this);
      this.ipcObj.readyCallback = this.ready.bind(this);
      this.ipcObj.imageDiv = this.imgDiv;
      this.ipcObj.init(this.htmlBody);
      if (this.ipcObj.imgElement) {
        this.topHeight = 499;
        this.bottomHeight = 499;
      } else {
        this.topHeight = 0;
        this.bottomHeight = this.state.global_screen_specs.workspaceHeight;
      }
      render(this.ipcTopicTemplate(), this.shadowRoot);
      this.top = this.shadowRoot.querySelector("#top");

      this.hsc = this.shadowRoot.querySelector("#helpsetcontainer");
      this.hsc.addEventListener(
        "splitter-dragend",
        this.updateScreenHeightSpecs.bind(this)
      );
      /*
            if(this.ipcObj.title){
                var figTitle = this.shadowRoot.querySelector("#figuretitle")
                if(!figTitle){
                    figTitle = document.createElement("div")
                    figTitle.id="figuretitle";
                    figTitle.innerHTML = this.ipcObj.title;
                    this.top.appendChild(figTitle);
                } else {
                    figTitle.innerHTML = this.ipcObj.title;
                    }
                }
            */
      setTimeout(
        function () {
          /* might have to replace this with some load detector in the ipcClass */
          this.updateScreenHeightSpecs();
        }.bind(this),
        500
      );
      //this.updateScreenHeightSpecs();
    }
  }
  updateScreenHeightSpecs(e) {
    if (this.top) {
      var foo = this.top.getBoundingClientRect();

      if (this.top.children[0].children[0]) {
        this.top.children[0].children[0].setAttribute(
          "width",
          parseInt(foo.width)
        );
        this.top.children[0].children[0].setAttribute(
          "height",
          parseInt(foo.height)
        );
        this.top.children[0].children[0].children[0].setAttribute(
          "width",
          parseInt(foo.width) + "px"
        );
        this.top.children[0].children[0].children[0].setAttribute(
          "height",
          parseInt(foo.height) + "px"
        );
      }
    }
  }

  handleHashChange(e) {
    this.hash = new URL(e.newURL).hash;
    this.refreshData();
    this.myRender();
  }

  ready() {
    this.bottom.appendChild(this.ipcObj.table);
    this.svg = this.ipcObj.svg;
    this.hash = window.location.hash;
    this.setFragementActive();
    window.addEventListener("hashchange", this.handleHashChange.bind(this));

    /*
        var circles = this.shadowRoot.querySelector("#myGroup");
        for(var i=0;i<circles.children[0].children.length;i++){
            circles.children[0].children[i].addEventListener("click", this.hsClick.bind(this))
        }
        */
  }

  ipcTopicTemplate() {
    return html`
      <style>
        #top {
          height: ${this.topHeight}px;
          overflow: auto;
        }
        #imgdiv {
          height: ${this.topHeight}px;
          width: 100%;
        }
        #bottom {
          height: ${this.bottomHeight}px;
          overflow: auto;
        }
        th.entry {
          top: 0;
          background-color: #eee;
        }

        table {
          border-collapse: separate;
          width: 100%;
        }
        table th {
          padding: 10px 20px;
        }
        table td {
          padding: 8px 16px;
        }
        .active {
          background-color: #c4e3ff;
        }
        table th {
          background: #eee;
          border: 1px solid black;
        }
        .PNGPartsTable {
          font-size: 1em;
          background-color: transparent;
        }
        .PNGPartsTable tbody tr.datarow {
          cursor: pointer;
        }
        .PNGPartsTable tbody tr.narow {
          background-color: #e0e0e0;
          cursor: not-allowed;
        }
        .PNGPartsTable tr.active {
          background-color: #c4e3ff;
        }
        .PNGPartsTable th {
          position: sticky;
          top: 0;
        }

        .orderbtn {
          cursor: pointer;
        }

        #figuretitle {
          position: absolute;
          top: 0;
          left: 0;
          padding: 10px;
        }
      </style>
      <vaadin-split-layout orientation="vertical" id="helpsetcontainer">
        <div id="top">
          <div id="imgdiv"></div>
        </div>
        <div id="bottom"></div>
      </vaadin-split-layout>
    `;
  }

  zoom() {
    console.log("zooming");
    this.svg.attr(
      "transform",
      "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")"
    );
  }
  hsClick(e) {
    this.hswasclicked = true;
    this.clearhighlights();
    var tData = {};
    tData.coid = e.currentTarget.getAttribute("coid");
    tData.partno = e.currentTarget.getAttribute("partNum");
    tData.posIndex = e.currentTarget.getAttribute("indexNum");
    e.currentTarget.setAttribute("opacity", "0.5");
    this.highLightArea(tData, "hs");
  }

  rowClick(e) {
    this.hswasclicked = false;
    this.clearhighlights();
    var tData = {};
    tData.coid = e.currentTarget.getAttribute("coid");
    tData.indexNum = e.currentTarget.getAttribute("index-num");
    tData.partno = e.currentTarget.cells[1].innerText;
    tData.posIndex = e.currentTarget.cells[0].innerText;

    this.highLightArea(tData, "row");
  }

  orderBtnClick(e) {
    var item = JSON.parse(e.currentTarget.getAttribute("item"));
    if (orderUrl) {
      window.open(`${orderUrl}${item.partno}`, '_blank')
    } else {
      storeInstance.dispatch("addOrderItem", item);
    }
  }

  clearhighlights() {
    for (var i = 0; i < this.ipcObj.hotspotGroup.children.length; i++) {
      this.ipcObj.hotspotGroup.children[i].setAttribute("opacity", "0.0");
    }
    for (var i = 0; i < this.ipcObj.tbody.children.length; i++) {
      this.ipcObj.tbody.children[i].classList.remove("active");
    }
  }

  highLightArea(tData, mode) {
    if (!this.hswasclicked) {
      for (var i = 0; i < this.ipcObj.hotspotGroup.children.length; i++) {
        if (
          this.ipcObj.hotspotGroup.children[i].getAttribute("coid") ==
          tData.indexNum
        ) {
          this.ipcObj.hotspotGroup.children[i].setAttribute("opacity", "0.5");
        }
      }
    }
    var matchVal = null;
    if (mode == "hs") {
      matchVal = tData.coid;
    } else {
      matchVal = tData.indexNum;
    }
    var rows = this.ipcObj.tbody.rows;
    for (var i = 0; i < rows.length; i++) {
      //if(rows[i].getAttribute("coid")==tData.coid){
      if (rows[i].getAttribute("index-num") == matchVal) {
        rows[i].classList.add("active");
        if (this.hswasclicked) {
          rows[i].scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
          /* 
                  var theadRect = this.ipcObj.thead.getBoundingClientRect()
                  if(theadRect){
                    this.bottom.scrollBy(0, (theadRect.bottom-theadRect.top)*-1);
                  }
                  */
        }
        break;
      }
    }
    this.myRender();
  }
}

customElements.define("kb-ipc-topic", KbIpcTopic);
